import Image from "next/image"

import { Buttons } from "components/Button"
import Hero from "components/Hero"
import Layout, { Container, Section } from "components/Layout"
import SEO from "components/Seo"
import { Heading } from "components/Text"
import Usps from "components/Usps"
import sectionTwoImg from "public/cctv-repair.webp"
import sectionFourImg from "public/commercial-cctv.webp"
import heroImg from "public/domestic-cctv.webp"
import sectionOneImg from "public/emergencies.webp"
import sectionThreeImg from "public/maintenance-packages.webp"

import type { NextPage } from "next"

const HomeCCTV: NextPage = () => {
  return (
    <>
      <SEO
        titleTag="Home CCTV | CCTV Installation Derbyshire | 3HCCTV &amp; Alarms"
        metaDescription="Our home CCTV team specialise in CCTV installation for domestic customers across Derbyshire, Nottinghamshire &amp; South Yorkshire."
        pageTitle="Home CCTV"
      />
      <Layout>
        <Hero
          image={heroImg}
          imageClass="!object-center"
          imageAlt="Domestic CCTV Derbyshire"
          heading="Home CCTV"
          subHeading="Installation &amp; Repairs"
        />

        <Usps />

        <Section>
          <Container className="flex gap-6 smmax:flex-col-reverse flex-wrap mdmin:items-center">
            <div className="flex-1">
              <Heading>Home CCTV installation</Heading>
              <p>
                <strong>
                  Protect your home with a hassle-free HD CCTV system. Security
                  cameras are a great security feature and visual deterrent and
                  a perfect addition to any home security system.
                </strong>
              </p>
              <p>
                Our CCTV systems allow you to keep a watchful eye on your home
                and loved ones from anywhere in the world from a free,
                user-friendly mobile app. One of our CCTV installers will carry
                out a survey of your premises if required to be able to
                recommend the ideal package for you. The installation process is
                a quick and efficient service carried out by our team of highly
                trained security engineers.
              </p>
              <Buttons
                buttons={[
                  { kind: "phone" },
                  {
                    href: "/products",
                    content: "Book online",
                    icon: "calendar-day"
                  }
                ]}
              />
            </div>
            <Image
              src={sectionOneImg}
              sizes="(max-width: 748px) 80vw, 40vw"
              alt="Home CCTV Derbyshire"
              placeholder="blur"
              className="mdmin:w-1/3 smmax:w-1/2 object-cover aspect-square"
            />
          </Container>
        </Section>

        <Section variant="gray-100">
          <Container className="flex gap-6 smmax:flex-col-reverse mdmin:flex-row-reverse flex-wrap mdmin:items-center">
            <div className="flex-1">
              <Heading>Home CCTV repairs</Heading>
              <p>
                We provide professional repairs for all types of home CCTV
                systems in the Midlands. A skilled member of our CCTV team can
                visit your home at a time suitable to you. Then our expert
                engineers will assess the fault and provide costings to either
                fix or replace the faulty equipment prior to any work being
                undertaken.
              </p>
              <Buttons
                buttons={[
                  { kind: "phone" },
                  {
                    href: "/products",
                    content: "Book online",
                    icon: "calendar-day"
                  }
                ]}
              />
            </div>
            <Image
              src={sectionTwoImg}
              sizes="(max-width: 748px) 80vw, 40vw"
              alt="Home CCTV repair Derbyshire"
              placeholder="blur"
              className="mdmin:w-1/3 smmax:w-1/2 object-cover aspect-square"
            />
          </Container>
        </Section>

        <Section>
          <Container className="flex gap-6 smmax:flex-col-reverse flex-wrap mdmin:items-center">
            <div className="flex-1">
              <Heading>Home CCTV maintenance packages</Heading>
              <p>
                We have a selection of maintenance packages perfect for our
                residential customers. Keep your system up to date and ensure
                you &amp; your belongings secure.
              </p>
              <Buttons
                buttons={[
                  { kind: "phone" },
                  {
                    href: "/products",
                    content: "Book online",
                    icon: "calendar-day"
                  }
                ]}
              />
            </div>
            <Image
              src={sectionThreeImg}
              sizes="(max-width: 748px) 80vw, 40vw"
              alt="Home CCTV maintenance packages Derbyshire"
              placeholder="blur"
              className="mdmin:w-1/3 smmax:w-1/2 object-cover aspect-square"
            />
          </Container>
        </Section>

        <Section variant="gray-100">
          <Container className="flex gap-6 smmax:flex-col-reverse mdmin:flex-row-reverse flex-wrap mdmin:items-center">
            <div className="flex-1">
              <Heading>Home security emergencies</Heading>
              <p>
                We operate an emergency callout repair and replacement service.
                Our team of security technicians can attend your home to assist
                with your security emergency and quickly restore your security
                system to full working order.
              </p>
              <Buttons
                buttons={[
                  { kind: "phone" },
                  {
                    href: "/products",
                    content: "Book online",
                    icon: "calendar-day"
                  }
                ]}
              />
            </div>
            <Image
              src={sectionFourImg}
              sizes="(max-width: 748px) 80vw, 40vw"
              alt="Home security emergencies Derbyshire"
              placeholder="blur"
              className="mdmin:w-1/3 smmax:w-1/2 object-cover aspect-square"
            />
          </Container>
        </Section>
      </Layout>
    </>
  )
}

export default HomeCCTV
